import Data from 'data';
import { skillAuraStats, skillFormula, skillPassiveStats } from 'logic/skills/calc';
import { DamageCalculator, missileDamage } from '../damage';
import { missileDPS } from '../dps';

const functions = {};

// Fist of the Heavens

functions[80] = {
  damage(skill, stats, weapon, level, target) {
    return missileDamage(Data.missileByName[skill.srvmissilea], stats, stats.weapon1, level, target);
  },
  dps(id, stats, level, target, info) {
    const skill = Data.skills[id];
    const missile = Data.missileByName[skill.srvmissilea];
    if (!missile) return;
    return missileDPS(skill, missile, stats, level, target, info);
  },
};

// Holy Freeze aura

functions[81] = {
  showActive: id => !!(Data.skills[id].aurastate || Data.skills[id].auratargetstate),
  group: () => 'aura',
  active: unit => ({
    active: unit === 'player' ? false : true,
  }),
  aura(id, stats, level, active, itemAura) {
    if (!itemAura && !(active || this.active(stats.unit)).active) return;
    const skill = Data.skills[id];
    return {
      level,
      filter: skill.aurafilter,
      state: skill.aurastate,
      stats: () => skillPassiveStats(skill, stats, level),
      targetState: skill.auratargetstate,
      targetStats: targetStats => {
        const result = skillAuraStats(skill, stats, level);
        for (const id in result) {
          result[id] = Math.max(result[id], targetStats.base.coldeffect);
        }
        return result;
      },
    };
  },
  damage(skill, stats, weapon, level, target) {
    const calc = new DamageCalculator(stats, weapon, false, false);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.srcdam(skill.srcdam);
    return calc.calculate(target);
  },
};

// Fire Hit

functions[83] = {
  showActive: id => !!Data.skills[id].aurastate,
  active: {
    active: false,
  },
  aura(id, stats, level, active) {
    if (!(active || this.active).active) return;
    const skill = Data.skills[id];
    if (!skill.aurastate) return;
    return {
      level,
      state: skill.aurastate,
      stats: () => skillAuraStats(skill, stats, level),
    };
  },
  damage(skill, stats, weapon, level, target) {
    if (!weapon) return null;
    const calc = new DamageCalculator(stats, weapon, false, true);
    if (skill.etype) {
      calc.elemental(skill.etype, skillFormula(skill, 'enms', stats, level),
        skillFormula(skill, 'exms', stats, level), skillFormula(skill, 'edln', stats, level));
    }
    calc.skillbonus('damagepercent', skillFormula(skill, 'clc1', stats, level));
    calc.convert(skill.etype, skillFormula(skill, 'clc4', stats, level));
    calc.srcdam(skill.srcdam);
    calc.skillbonus('tohit_percent', skillFormula(skill, 'toht', stats, level));
    calc.resultflags = skill.resultflags;
    return calc.calculate(target);
  },
};

export default functions;
